var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "klienti-tabs w-tabs",
    attrs: {
      "data-current": "Tab 1",
      "data-easing": "ease",
      "data-duration-in": "300",
      "data-duration-out": "100"
    }
  }, [_c('div', {
    staticClass: "klienti-tabs w-tab-menu"
  }, _vm._l(Object.keys(_vm.clientsConfig), function (type, index) {
    return _c('a', {
      key: index,
      staticClass: "tab-link-broker w-inline-block w-tab-link no-decoration",
      "class": [_vm.activeTab === type ? 'w--current' : ''],
      attrs: {
        "data-w-tab": "Tab 1"
      },
      on: {
        "click": function click($event) {
          return _vm.switchTabs(type);
        }
      }
    }, [_c('div', {
      staticClass: "noselect"
    }, [_vm._v(_vm._s(_vm.cardLabelsDict[type]) + " (" + _vm._s(_vm.getClientsCountByType(type)) + ")")])]);
  }), 0), _c('div', {
    staticClass: "tabs-content-3 w-tab-content"
  }, [_c('div', {
    staticClass: "tab-pane-klienti w-tab-pane w--tab-active",
    attrs: {
      "data-w-tab": "Tab 1",
      "data-w-id": "155033eb-2d0e-aa7b-9a05-cefed74ed377"
    }
  }, [_c('div', {
    staticClass: "klienti-list"
  }, [_vm._l(_vm.activeTabClients, function (client, index) {
    return _c(_vm.getClientComponent(client), {
      key: client.id,
      tag: "component",
      attrs: {
        "client": client
      }
    });
  }), _vm.loading ? _c('div', {
    staticClass: "text-center mb-2"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()], 2)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }